module.exports = __webpack_public_path__ + "static/media/img-access-map.8851b352.jpg";